import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import KabobMenu from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import DuplicateScenarioKabobItem
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/FacetPlanSummaryKabobMenu/DuplicateScenarioKabobItem';
import ChangeStartDateKabobItem
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/FacetPlanSummaryKabobMenu/ChangeStartDateKabobItem';
import { pickFunction } from 'Helpers/Affordances';
import ClickToSyncKabobItem
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/FacetPlanSummaryKabobMenu/ClickToSyncKabobItem';
import PreviewScenarioKabobItem
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/FacetPlanSummaryKabobMenu/PreviewScenarioKabobItem';

const styles = () => ({});

const FacetPlanSummaryKabobMenu = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <React.Fragment>
      <KabobMenu test={'facet-plan-summary-kabob-menu'}>
        {pickFunction(pageContentResource, {
          [fr.relationships.facetPlanViewDuplicatePlan.name]: () => (
            <DuplicateScenarioKabobItem />
          ),
          [fr.relationships.default.name]: () => null,
        })}
        {pickFunction(pageContentResource, {
          [fr.relationships.clickToSync.name]: () => (
            <ClickToSyncKabobItem />
          ),
          [fr.relationships.default.name]: () => null,
        })}
        {pickFunction(pageContentResource, {
          [fr.relationships.facetPlanSummary.name]: () => (
            <ChangeStartDateKabobItem />
          ),
          [fr.relationships.default.name]: () => null,
        })}
        {pickFunction(pageContentResource, {
          [fr.relationships.planPage.name]: () => (
            <PreviewScenarioKabobItem />
          ),
          [fr.relationships.default.name]: () => null,
        })}
      </KabobMenu>
    </React.Fragment>
  );
};

FacetPlanSummaryKabobMenu.defaultProps = {};

FacetPlanSummaryKabobMenu.propTypes = {};

export default withStyles(styles)(FacetPlanSummaryKabobMenu);
